<template>
  <fragment>
    <ws-list-view-item-column>
      <span data-id="shift-number" v-if="props.index === 0" v-text="shift.number"></span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <span data-id="shift-row-number" v-if="props.index === 0" v-text="props.row.number"></span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <span class="display-block">
        <ws-icon v-if="universityVisible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
        <router-link :to="`/orgs/${props.row.university.guid}/groups`">{{ universityTitle }}</router-link> <br/>
       <ws-curator-list  :curators="curators"/></span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <span
        v-if="props.row.education_group"
        data-id="shift-education-group-name"
        v-text="props.row.education_group.name"
      ></span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <span data-id="shift-row-student" v-text="props.row.student || '0'"></span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <span>{{ props.row.independent_estimate_participants_number }}</span>
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <ws-time-formatter data-id="shift-job-issued-at" v-if="props.index === 0" :date="shift.job_issued_at" />
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <ws-time-formatter data-id="shift-started-at" v-if="props.index === 0" :date="shift.started_at" />
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <ws-time-formatter data-id="shift-ended-at" v-if="props.index === 0" :date="shift.ended_at" />
    </ws-list-view-item-column>
    <ws-list-view-item-column>
      <div v-if="props.index === 0" class="is-fullwidth has-text-right">
        <span v-if="props.index === 0">
          <b-tooltip :label="$t('Редактировать')" type="is-dark">
            <button
              :disabled="isDisableForRole"
              class="button is-text"
              :aria-label="$t('Редактировать')"
              @click="editItem({ group: props.row, shift })">
              <ws-icon
                class="ws-button__icon"
                name="edit"
                color="#6D9AE8"
                :fill="false"
                width="14"
                height="14"
              />
            </button>
          </b-tooltip>
          <b-tooltip :label="$t('Сделать копию')" type="is-dark" class="is-loading">
            <button
              :disabled="isDisableForRole"
              class="button is-text"
              :aria-label="$t('Сделать копию')"
              @click="cloneItem({ group: props.row, shift })"
              :class="{'is-loading': isClonePending  }">
              <ws-icon
                :style="{'visibility': isClonePending ? 'hidden' : 'visible' }"
                class="ws-button__icon"
                name="copy"
                color="#6D9AE8"
                :fill="false"
                width="14"
                height="14"
              />
            </button>
          </b-tooltip>
        </span>
        <b-tooltip :label="$t('Удалить смену')" type="is-danger">
          <button
            :disabled="isDisableForRole"
            class="button is-text" :aria-label="$t('Удалить смену')"
            @click="removeItem(shift)"
            :class="{'is-loading': isRemovePending }">
            <ws-icon
              :style="{'visibility': isRemovePending ? 'hidden' : 'visible' }"
              class="ws-button__icon"
              name="trash"
              color="#6D9AE8"
              :fill="false"
              width="14"
              height="14"
            />
          </button>
        </b-tooltip>
      </div>
    </ws-list-view-item-column>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import WsRequestExamsChooseGroup from '@/components/de/request-exams/modals/WsRequestExamsChooseGroup'
import { constants } from '@/services/constants.service'
import WsCuratorList from '@/components/de/demo-exams/WsCuratorList.vue'
export default {
  name: 'WsExamsShiftsListItem',
  components: { WsCuratorList },
  props: {
    shift: Object,
    exam: {
      type: Object
    },
    props: {
      type: Object
    },
    curators: {
      type: Array
    }
  },
  data () {
    return {
      isClonePending: false,
      isRemovePending: false,
      constants
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole']),
    isDisableForRole () {
      return (this.currentRole === 'front_curator' &&
      !([this.constants.request_exams_status.NEW, this.constants.request_exams_status.REVISION_AUTH_ORG].includes(this.exam.status))) ||
      (this.currentRole === 'front_rcc' &&
      ([this.constants.request_exams_status.REVIEW_DE_DEPARTMENT, this.constants.request_exams_status.AGREED_DE_DEPARTMENT].includes(this.exam.status)))
    },
    universityTitle () {
      const { row } = this.props
      const title = get(row, 'university.title.display', '')
      const eduGroupUniversityTitle = get(row, 'education_group.university.title.display', '')
      return title || eduGroupUniversityTitle
    },
    universityVisible () {
      const { row } = this.props
      const visible = get(row, 'university.visible', true)
      const eduGroupUniversityVisible = get(row, 'education_group.university.visible', true)
      return visible || eduGroupUniversityVisible
    }
  },
  methods: {
    ...mapActions('exams/shifts', {
      createGroup: 'create',
      remove: 'remove'
    }),
    getIndependentEstimateParticipantsNumber (item) {
      return item.independent_estimate_participants_number ? item.independent_estimate_participants_number : '-'
    },
    editItem (options) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsChooseGroup,
        hasModalCard: true,
        props: {
          exam: this.exam,
          shift: Object.assign({}, options.shift)
        },
        events: {
          'onUpdateItem': () => {
            this.$emit('shift-update')
          }
        },
        canCancel: false
      })
    },
    cloneItem (item) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsChooseGroup,
        hasModalCard: true,
        props: {
          exam: this.exam,
          shift: Object.assign({}, item.shift),
          isClone: true
        },
        events: {
          'onUpdateItem': () => {
            this.$emit('shift-update')
          }
        },
        canCancel: false
      })
    },
    removeItem (item) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить смену № «${item.number}»?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.isRemovePending = true
            await this.remove([this.exam.guid, {}, `/shifts/${item.guid}`])
            this.$emit('shift-update')
            this.$buefy.toast.open({
              message: this.$t(`Смена № «${item.number}» была успешно удалена`),
              type: 'is-success'
            })
          } catch (e) {
            this.$buefy.toast.open({
              message: this.$t('Что-то пошло не так. Попробуйте еще раз'),
              type: 'is-danger'
            })
          } finally {
            this.isRemovePending = false
          }
        }
      })
    }
  }
}
</script>
